module.exports = __webpack_public_path__ + "27f4b8bdb839fc3ca0270557722d73fd.jpg";